import React from "react";
import { NewModal } from "../uiMerge/newModal";

type MerhcantInfoModalProps = {
  visible: boolean;
  onCancel: () => void;
  offerName: string | any;
  offerTOR: string;
};
const TermsAndConditionsModal: React.FC<MerhcantInfoModalProps> = ({
  visible,
  onCancel,
  offerTOR,
  offerName,
}: MerhcantInfoModalProps) => {
  return (
    <NewModal
      isOpen={visible}
      roundedClass="rounded-[10px]"
      colorClass="bg-black"
      widthClass="w-[335px]"
      heightClass="min-h-[255px]"
      position="center"
      showCloseButton
      onClose={onCancel}
    >
      <div className="flex flex-col  mt-9 items-center py-[30px] px-[15px] gap-3">
        <p className="font-extrabold text-white text-center text-[20px]">
          Terms and Conditions
        </p>
        <p className="font-extrabold text-white text-center text-[16px]">
          {offerName}
        </p>
        <div className="overflow-y-auto show-scrollbar max-h-[250px]">
          <p className="text-white text-center text-[14px] px-2;5">
            {offerTOR}
          </p>
        </div>
      </div>
    </NewModal>
  );
};

export default TermsAndConditionsModal;
